import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import type { UsersFilterState } from './components/UsersFilterBar';
import { readUsersFilters, writeUsersFilters } from './users-filter-params';

/** Keeps the Users list filters in the page address so a refresh or a shared
 *  link reopens the same view. Writes replace the current history entry, so
 *  typing in search does not stack up Back-button steps. */
export function useUsersFilterParams(
  allowedRegionIds: readonly string[],
): [UsersFilterState, (next: UsersFilterState) => void] {
  const [params, setParams] = useSearchParams();

  const filters = useMemo(
    () => readUsersFilters(params, allowedRegionIds),
    [params, allowedRegionIds],
  );

  const setFilters = useCallback(
    (next: UsersFilterState) =>
      setParams((current) => writeUsersFilters(current, next), { replace: true }),
    [setParams],
  );

  return [filters, setFilters];
}
